export var DEPLOY_DATE = new Date('2026-10-12T21:05:15+0000');
